<template>
  <el-row>
    <div id="qiuEchart1" :style="{ width: '120px', height: '120px' }"></div>
    <div id="qiuEchart2" :style="{ width: '120px', height: '120px' }"></div>
    <div id="qiuEchart3" :style="{ width: '120px', height: '120px' }"></div>
    <div id="qiuEchart4" :style="{ width: '120px', height: '120px' }"></div>
  </el-row>
</template>

<script>
import {onMounted, onUnmounted } from 'vue'
import * as echarts from "echarts";
import 'echarts-liquidfill'
export default {
  name: "qiuEchart",
  data(){
    return {
    }
  },
  setup() {
    /// 声明定义一下echart
    let echart = echarts;
    onMounted(() => {
      qiuEchart1();
      qiuEchart2();
      qiuEchart3();
      qiuEchart4();
    });
    onUnmounted(() => {
      echart.dispose();
    });
    function qiuEchart1() {
      let chart = echart.init(document.getElementById("qiuEchart1"));
      // 把配置和数据放这里
      chart.setOption({
        series: [{
            type: 'liquidFill',
            data: [0.57],
            radius: '70%',
            name: '发明专利比例',
            itemStyle: {
              normal: {
                color: '#2648ff'
              },
              // #02eeea
            },
            label: {
              normal:{
                color: '#fff',// 57%字体的颜色
                fontSize: 14,
              }
            },
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderColor: '#2648ff',
                borderWidth: 2,
              }
            },
            backgroundStyle: {
              color: 'transparent',
            },
        }]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function qiuEchart2() {
      let chart = echart.init(document.getElementById("qiuEchart2"));
      // 把配置和数据放这里
      chart.setOption({
        series: [{
            type: 'liquidFill',
            data: [0.76],
            radius: '70%',
            name: '授权比例',
            itemStyle: {
              normal: {
                color: '#d6b33f'
              },
              // #02eeea
            },
            label: {
              normal:{
                color: '#fff',// 57%字体的颜色
                fontSize: 14,
              }
            },
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderColor: '#2648ff',
                borderWidth: 2,
              }
            },
            backgroundStyle: {
              color: 'transparent',
            },
        }]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function qiuEchart3() {
      let chart = echart.init(document.getElementById("qiuEchart3"));
      // 把配置和数据放这里
      chart.setOption({
        series: [{
            type: 'liquidFill',
            data: [0.33],
            radius: '70%',
            name: '有效比例',
            itemStyle: {
              normal: {
                color: '#409eff'
              },
              // #02eeea
            },
            label: {
              normal:{
                color: '#fff',// 57%字体的颜色
                fontSize: 14,
              }
            },
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderColor: '#2648ff',
                borderWidth: 2,
              }
            },
            backgroundStyle: {
              color: 'transparent',
            },
        }]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function qiuEchart4() {
      let chart = echart.init(document.getElementById("qiuEchart4"));
      // 把配置和数据放这里
      chart.setOption({
        series: [{
            type: 'liquidFill',
            data: [0.19],
            radius: '70%',
            name: '有效发明比例',
            itemStyle: {
              normal: {
                color: '#02eeea'
              },
            },
            label: {
              normal:{
                color: '#fff',// 57%字体的颜色
                fontSize: 14,
              }
            },
            outline: {
              borderDistance: 3,
              itemStyle: {
                borderColor: '#2648ff',
                borderWidth: 2,
              }
            },
            backgroundStyle: {
              color: 'transparent',
            },
        }]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    return { qiuEchart1,qiuEchart2,qiuEchart3,qiuEchart4};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
